<div class="fail-retrieve-content">
  <h2 class="header">{{modalTitle}}</h2>
  <p class="message-content" [innerHTML]="modalContent | translate"></p>
  <div *ngIf="showTryAgainButton" class="button-groups d-flex flex-row justify-content-end">
    <button class="button" (click)="onTryAgain()">{{btnLabel}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component.html